import { combineSlices } from "@reduxjs/toolkit";
import cookie from "js-cookie";
import config from "configuration";
import auth from "./modules/auth";
import global from "./modules/global";
import user from "./modules/user";
import mainPages from "./modules/mainPages";

// ** Global
import globalCommon from "./modules/global-common.slice";
import globalViewTypes from "./modules/global-view-types.slice";
import sharedFilters from "./modules/shared-filters.slice";

// ** Landing
import landing from "./modules/landing.slice";

// ** Main Pages
import mainPageHome from "./modules/main-pages/home/home.slice";
import mainPagePosts from "./modules/main-pages/posts/posts.slice";
import galleriesAll from "./modules/main-pages/galleries/galleries-all.slice";
import galleriesVideos from "./modules/main-pages/galleries/galleries-videos.slice";
import galleriesPhotos from "./modules/main-pages/galleries/galleries-photos.slice";
import mainPageSeoLocationsList from "./modules/main-pages/seo-locations-list/seo-locations-list.slice";
import mainPageSeoPreferencesList from "./modules/main-pages/seo-preferences-list/seo-preferences-list.slice";
import mainPageRankings from "./modules/main-pages/rankings/rankings.slice";
import mainPageUsers from "./modules/main-pages/users/users.slice";

// ** User Profile
import userProfileMain from "./modules/user-profile/user-profile-main.slice";
import userProfileMainContent from "./modules/user-profile/user-profile-main-content.slice";
import userProfileFriends from "./modules/user-profile/user-profile-friends.slice";

// ** Service Pages
import servicePageApp from "./modules/service-pages/app.slice";
import servicePageSupport from "./modules/service-pages/support.slice";
import servicePageTerms from "./modules/service-pages/terms.slice";
import servicePagePrivacy from "./modules/service-pages/privacy.slice";
import servicePageContact from "./modules/service-pages/contact.slice";
import servicePageNews from "./modules/service-pages/news.slice";

// ** Defaults
import initialState from "./defaults";

export const SET_INITIAL_STATE = "root/SET_INITIAL_STATE";

function crossSliceReducer(state, action) {
	switch (action.type) {
		case SET_INITIAL_STATE: {
			cookie.remove(config.auth.cookieName, { path: "/" });
			// const languageFromCookie = cookie.get(config.language.cookieName, {
			// 	path: "/",
			// });

			// const finalLanguage = languageFromCookie
			// 	? languageFromCookie.slice(0, 2)
			// 	: "pl";
			return {
				...state,
				auth: {
					...initialState.auth,
				},
				global: {
					...initialState.global,
					// language: finalLanguage ?? initialState.global.language,
				},
				landing: {
					...initialState.landing,
					loaded: null,
				},
				user: {
					...initialState.user,
				},
			};
		}
		default:
			return state;
	}
}

export function setInitialState() {
	return {
		type: SET_INITIAL_STATE,
	};
}

const staticReducers = {
	auth,
	global,

	// ** Global
	globalCommon,
	globalViewTypes,
	sharedFilters,

	// ** Landing
	landing,

	// ** User
	user,

	// ** Main Pages
	mainPages,
	mainPageHome,
	mainPagePosts,
	galleriesAll,
	galleriesVideos,
	galleriesPhotos,
	mainPageSeoLocationsList,
	mainPageSeoPreferencesList,
	mainPageRankings,
	mainPageUsers,

	// ** User Profile
	userProfileMain,
	userProfileMainContent,
	userProfileFriends,

	// ** Service Pages
	servicePageApp,
	servicePageSupport,
	servicePageTerms,
	servicePagePrivacy,
	servicePageContact,
	servicePageNews,
};

export const injectReducers = (store, reducers) => {
	// Inicjalizacja asyncReducers jeśli nie istnieją
	if (!store.asyncReducers) store.asyncReducers = {};

	// Obsługa pojedynczego reducera (zachowanie kompatybilności wstecznej)
	if ("key" in reducers && "reducer" in reducers) {
		store.asyncReducers[reducers.key] = reducers.reducer;
	}
	// Obsługa wielu reducerów jako obiekt { [key]: reducer }
	else if (typeof reducers === "object") {
		store.asyncReducers = {
			...store.asyncReducers,
			...reducers,
		};
	}

	// Aktualizacja store z nowymi reducerami
	store.replaceReducer(
		combineSlices(
			{
				...staticReducers,
				...store.asyncReducers,
			},
			crossSliceReducer
		)
	);
};

// Zachowujemy starą funkcję dla kompatybilności wstecznej
export const injectReducer = (store, { key, reducer }) => {
	injectReducers(store, { key, reducer });
};

const createRootReducer = (asyncReducers = {}) =>
	combineSlices(
		{
			...staticReducers,
			...asyncReducers,
		},
		crossSliceReducer
	);

export default createRootReducer;
